import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type CustomerShortCode = { short_code: string; organization_name: string | null };

/**
 * Every carrier SCAC / customer short code (e.g. WENP), regardless of the
 * caller's customer/tenant mappings. Shared by Yard Check-In and the driver
 * Verify Trailer screen so both dropdowns always list the same carriers.
 *
 * Served by the `customers` edge function (GET /customers/scac-options),
 * whose query lives in supabase/functions/_shared/models/customer/queries.ts
 * and already returns rows ordered by short code.
 */
export function useCustomerShortCodes() {
  return useQuery({
    queryKey: ["customer-scac-options"],
    queryFn: async (): Promise<CustomerShortCode[]> => {
      const { data, error } = await supabase.functions.invoke<CustomerShortCode[]>("customers/scac-options", {
        method: "GET",
      });
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 5 * 60 * 1000, // customers change rarely; these screens open often
  });
}
